/**
 * @file Input component for linkedin input
 * @author Heino Lenting
 */
import * as tslib_1 from "tslib";
import { InputStringBase } from '../../../base/helpers/input-string-base';
import { LinkedInValidator, NAME_LINKEDIN_VALIDATOR } from '../../../core/validators/linkedin.validator';
import { Validator } from 'breeze-client';
import { SettingsService } from '../../../settings.service';
/**
 * Class for the linkedin input component
 */
var InputLinkedinComponent = /** @class */ (function (_super) {
    tslib_1.__extends(InputLinkedinComponent, _super);
    /**
     * Creates an instance of InputLinkedinComponent.
     * @param {SettingsService} settingsService Service to get the application settings.
    * */
    function InputLinkedinComponent(settingsService) {
        var _this = _super.call(this) || this;
        _this.settingsService = settingsService;
        return _this;
    }
    Object.defineProperty(InputLinkedinComponent.prototype, "url", {
        get: function () {
            return this.settingsService.settings.frontend.social.linkedin + this.value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Validates a value
     * @param newValue The value to be validated
     * @returns A value indicating whether the value is valid
     * @returns {ValidationErrors} has errors if value is false
     * @memberOf InputLinkedinComponent
     */
    InputLinkedinComponent.prototype.isValidValue = function (newValue) {
        var _a;
        if (LinkedInValidator().validate(newValue)) {
            var errorKey = NAME_LINKEDIN_VALIDATOR;
            return _a = {},
                _a[errorKey] = Validator.messageTemplates[errorKey],
                _a;
        }
        return null;
    };
    /**
     * The default angular control validator based upon the url breeze.js validator.
     * @protected
     * @returns {(ValidatorFn | ValidatorFn[])} An angular control validator.
     */
    InputLinkedinComponent.prototype.defaultControlValidator = function () {
        var self = this;
        return function (c) {
            return self.isValidValue(c.value);
        };
    };
    return InputLinkedinComponent;
}(InputStringBase));
export { InputLinkedinComponent };
